import React from 'react'

const SevenYearModel = () => {
  return (
    <section className='seven-year-model bg-light'>
        <div className="container">
            <div className="row">
                <div className="seven-year-model-image col-lg-7 col-12 bg-primary">
                    <img src='img/community-model.jpg' style={{borderRadius:'10px'}} className="volunteer-image img-fluid" alt="Community Model" />
                </div>

                <div className="col-lg-5 col-12 d-flex flex-column justify-content-center">
                    <h2 className="mb-4 mt-2 text-center">Partner with Us</h2>
                    <h4 className="mb-4">To design &amp; implement collectively a Model 7-year Comprehensive Development Plan for Your Community &amp; People</h4>
                    <div style={{textAlign:'center'}}>
                        <a
                            href="mailto:info@phgfoundationafrica.org?subject=Applying for Seven Year Model Community Program"
                            style={{width:'70%', display:'inline-block'}}
                            className='btn btn-primary p-2'
                        >
                            Apply Now
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default SevenYearModel
